<div class="app-text-chat-actions">
  <div *ngIf="isInProgress" class="text-chat-typing-info">
    <div class="typing-list js-typing-info" [hidden]="!isUserTyping">
      <span>{{ 'bcTextChatActions.isTypingNotification' | translate }}</span>
    </div>
  </div>

  <div *ngIf="isInProgress && messages.length === 0" class="bc-empty-state">
    <span>{{ 'bcTextChatActions.noMessages' | translate: { visitorName: visitorName || ('bcTextChatActions.visitor' | translate) } }}</span>
  </div>

  <div *ngIf="isAnswerable" class="claim-text-chat-panel">
    <button class="btn btn-dark center js-answer-text-chat-button" (click)="onAnswerTextChat()">
      <span>{{ 'bcTextChatActions.answerTextChatButton' | translate }}</span>
    </button>
  </div>
</div>

